{
  "familyId": "SWW-TT-STAM",
  "questions": [
    {
      "id": "SWW-TT-STAM-001",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "multiple_choice",
      "question": "De postbode zegt: 'Ik ... elke dag naar school.' (fietsen)",
      "options": ["fiets", "fietst", "fietste", "gefietst"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "fietsen",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["fiets", "fietst", "fietst"],
            "highlight": "ik",
            "label": "Tegenwoordige Tijd"
          }
        }
      ],
      "supportAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "fietsen",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["fiets", "fietst", "fietst"],
            "highlight": "ik",
            "label": "Tegenwoordige Tijd"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "present_tense_first_person_stem",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Bepaal eerst de stam: werkwoord 'fietsen' min -en = 'fiets'. Bij 'ik' gebruik je alleen de stam, zonder -t. Dus: ik fiets.",
        "solutionSteps": [
          "Bepaal de stam: fietsen − en = fiets",
          "Bij 'ik' gebruik je alleen de stam (geen -t)",
          "Antwoord: ik fiets"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Fiets' is de stam. Bij 'ik' gebruik je alleen de stam zonder -t.",
          "1": "Je dacht waarschijnlijk dat 'ik' ook een -t krijgt. Maar bij 'ik' gebruik je alleen de stam, zonder -t. De -t komt alleen bij hij/zij/het: hij fietst. Onthoud: ik = stam, hij/zij = stam + t.",
          "2": "Je dacht waarschijnlijk dat dit verleden tijd is. Maar 'fietste' is verleden tijd. Het signaalwoord 'elke dag' wijst op tegenwoordige tijd. Onthoud: kijk naar het signaalwoord.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'gefietst' hoort bij een hulpwerkwoord (heb gefietst). Hier staat geen hulpwerkwoord, dus gewoon de stam: fiets."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "sww.ik-vorm-met-t", "label": "Bij ik-vorm onnodig -t toegevoegd", "optionIndex": 1 },
          { "id": "sww.vt-ipv-tt", "label": "Verleden tijd gebruikt bij tegenwoordige context", "optionIndex": 2 },
          { "id": "sww.inversie-vd-gebruikt", "label": "Voltooid deelwoord zonder hulpwerkwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-STAM-002",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "multiple_choice",
      "question": "De bibliothecaris ... een boek. (lezen)",
      "options": ["leest", "lees", "las", "gelezen"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "lezen",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["lees", "leest", "leest"],
            "highlight": "hij/zij",
            "label": "Tegenwoordige Tijd"
          }
        }
      ],
      "supportAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "lezen",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["lees", "leest", "leest"],
            "highlight": "hij/zij",
            "label": "Tegenwoordige Tijd"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "present_tense_third_person_basic",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Bepaal de stam: lezen − en = leez → lees (z wordt s aan het eind van een woord). Bij hij/zij/het voeg je -t toe aan de stam: lees + t = leest. Dus: de bibliothecaris leest.",
        "solutionSteps": [
          "Bepaal de stam: lezen − en = leez → lees (z → s)",
          "'De bibliothecaris' = hij/zij → stam + t",
          "lees + t = leest"
        ],
        "distractorExplanations": {
          "0": "Goed! Bij hij/zij voeg je -t toe aan de stam: lees + t = leest.",
          "1": "Je dacht waarschijnlijk dat de ik-vorm hier past. Maar 'lees' is de stam (ik-vorm). 'De bibliothecaris' is hij/zij, dus je voegt -t toe: leest. Onthoud: hij/zij/het krijgt altijd -t.",
          "2": "Je dacht waarschijnlijk dat dit verleden tijd is. Maar 'las' is de verleden tijd (sterk werkwoord). Er is geen signaalwoord voor verleden tijd, dus tegenwoordige tijd: leest. Onthoud: kijk naar het signaalwoord.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'gelezen' hoort bij 'heeft gelezen'. Hier staat geen hulpwerkwoord 'heeft', dus gewoon tegenwoordige tijd: leest."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "sww.heel-ww-ipv-stam", "label": "Stam (ik-vorm) gebruikt bij hij/zij", "optionIndex": 1 },
          { "id": "sww.vt-ipv-tt", "label": "Verleden tijd gebruikt bij tegenwoordige context", "optionIndex": 2 },
          { "id": "sww.inversie-vd-gebruikt", "label": "Voltooid deelwoord zonder hulpwerkwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-STAM-003",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "multiple_choice",
      "question": "De voetballer ... de bal ver weg. (trappen)",
      "options": ["trapt", "trap", "trapte", "getrapt"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "trappen",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["trap", "trapt", "trapt"],
            "highlight": "hij/zij",
            "label": "Tegenwoordige Tijd"
          }
        }
      ],
      "supportAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "trappen",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["trap", "trapt", "trapt"],
            "highlight": "hij/zij",
            "label": "Tegenwoordige Tijd"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "present_tense_third_person_add_t",
      "variantIndex": 3,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bepaal de stam: trappen − en = trapp → trap (dubbele medeklinker wordt enkel). Bij hij/zij/het voeg je altijd -t toe: trap + t = trapt. Dus: de voetballer trapt.",
        "solutionSteps": [
          "Bepaal de stam: trappen − en = trapp → trap",
          "'De voetballer' = hij → stam + t",
          "trap + t = trapt"
        ],
        "distractorExplanations": {
          "0": "Goed! Bij hij voeg je -t toe aan de stam: trap + t = trapt.",
          "1": "Je dacht waarschijnlijk dat de ik-vorm hier past. Maar 'trap' is de stam (ik-vorm). 'De voetballer' is hij, dus je voegt -t toe: trapt. Onthoud: hij/zij/het krijgt altijd -t.",
          "2": "Je dacht waarschijnlijk dat dit verleden tijd is. Maar 'trapte' is de verleden tijd. Er is geen signaalwoord voor verleden tijd, dus tegenwoordige tijd: trapt. Onthoud: kijk naar het signaalwoord.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'getrapt' hoort bij 'heeft getrapt'. Hier staat geen hulpwerkwoord, dus gewoon tegenwoordige tijd: trapt."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "sww.heel-ww-ipv-stam", "label": "Stam (ik-vorm) gebruikt bij hij/zij", "optionIndex": 1 },
          { "id": "sww.vt-ipv-tt", "label": "Verleden tijd gebruikt bij tegenwoordige context", "optionIndex": 2 },
          { "id": "sww.inversie-vd-gebruikt", "label": "Voltooid deelwoord zonder hulpwerkwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-STAM-004",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "multiple_choice",
      "question": "Wat is de stam van het werkwoord 'rennen'?",
      "options": ["ren", "rent", "renn", "rende"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Stam bepalen",
            "content": "De stam vind je door -en van het hele werkwoord af te halen: rennen → renn → ren. Let op: dubbele medeklinkers worden enkel aan het eind van een woord.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "stem_finding_double_consonant",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De stam vind je door -en af te halen: rennen → renn. Een woord eindigt niet op een dubbele medeklinker, dus renn → ren. De stam is 'ren'.",
        "solutionSteps": [
          "Haal -en af: rennen → renn",
          "Dubbele medeklinker wordt enkel aan het eind: renn → ren",
          "De stam is 'ren'"
        ],
        "distractorExplanations": {
          "0": "Goed! Rennen − en = renn → ren (dubbele medeklinker wordt enkel aan het eind).",
          "1": "Je dacht waarschijnlijk dat de hij-vorm de stam is. Maar 'rent' is stam + t (hij rent). De stam zelf is 'ren', zonder -t. Onthoud: de stam is het werkwoord zonder -en.",
          "2": "Je dacht waarschijnlijk dat de dubbele medeklinker blijft staan. Maar 'renn' klopt niet — een Nederlands woord eindigt niet op een dubbele medeklinker. De stam is 'ren'. Onthoud: dubbel wordt enkel aan het eind.",
          "3": "Je dacht waarschijnlijk dat de verleden tijd de stam is. Maar 'rende' is de verleden tijd. De stam vind je door -en af te halen: rennen − en = ren. Onthoud: stam = werkwoord zonder -en."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.heel-ww-ipv-stam", "label": "Hij-vorm aangezien voor stam", "optionIndex": 1 },
          { "id": "sww.dt-overgeneralize", "label": "Dubbele medeklinker behouden in stam", "optionIndex": 2 },
          { "id": "sww.vt-ipv-tt", "label": "Verleden tijd aangezien voor stam", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-STAM-005",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "multiple_choice",
      "question": "De verpleegkundige zegt: 'Ik ... graag in het park.' (wandelen)",
      "options": ["wandel", "wandelt", "wandelde", "gewandeld"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "wandelen",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["wandel", "wandelt", "wandelt"],
            "highlight": "ik",
            "label": "Tegenwoordige Tijd"
          }
        }
      ],
      "supportAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "wandelen",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["wandel", "wandelt", "wandelt"],
            "highlight": "ik",
            "label": "Tegenwoordige Tijd"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "present_tense_first_person_stem_long",
      "variantIndex": 5,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Bepaal de stam: wandelen − en = wandel. Bij 'ik' gebruik je alleen de stam, zonder -t. Dus: ik wandel.",
        "solutionSteps": [
          "Bepaal de stam: wandelen − en = wandel",
          "Bij 'ik' gebruik je alleen de stam (geen -t)",
          "Antwoord: ik wandel"
        ],
        "distractorExplanations": {
          "0": "Goed! De stam van 'wandelen' is 'wandel'. Bij 'ik' gebruik je alleen de stam.",
          "1": "Je dacht waarschijnlijk dat 'ik' ook -t krijgt. Maar 'wandelt' is de hij/zij-vorm (stam + t). Bij 'ik' voeg je geen -t toe. Onthoud: ik = stam, hij/zij = stam + t.",
          "2": "Je dacht waarschijnlijk dat dit verleden tijd is. Maar 'wandelde' is de verleden tijd. Er is geen signaalwoord voor verleden tijd, dus tegenwoordige tijd: ik wandel. Onthoud: kijk naar het signaalwoord.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'gewandeld' hoort bij 'heb gewandeld'. Hier staat geen hulpwerkwoord, dus gewoon de stam: wandel."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "sww.ik-vorm-met-t", "label": "Bij ik-vorm onnodig -t toegevoegd", "optionIndex": 1 },
          { "id": "sww.vt-ipv-tt", "label": "Verleden tijd gebruikt bij tegenwoordige context", "optionIndex": 2 },
          { "id": "sww.inversie-vd-gebruikt", "label": "Voltooid deelwoord zonder hulpwerkwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-STAM-006",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "fill_in",
      "question": "Vul in: 'Ik ... graag muziek.' (luisteren) Typ alleen het werkwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["luister"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "luisteren",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["luister", "luistert", "luistert"],
            "highlight": "ik",
            "label": "Tegenwoordige Tijd"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "present_tense_first_person_stem_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bepaal de stam: luisteren − en = luister. Bij 'ik' gebruik je alleen de stam, zonder -t. Dus: ik luister.",
        "solutionSteps": [
          "Bepaal de stam: luisteren − en = luister",
          "Bij 'ik' gebruik je alleen de stam (geen -t)",
          "Antwoord: luister"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "sww.ik-vorm-met-t", "label": "Bij ik-vorm onnodig -t toegevoegd" }
        ]
      }
    },
    {
      "id": "SWW-TT-STAM-007",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "fill_in",
      "question": "Vul in: 'De kok ... het eten.' (proeven) Typ alleen het werkwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["proeft"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "proeven",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["proef", "proeft", "proeft"],
            "highlight": "hij/zij",
            "label": "Tegenwoordige Tijd"
          },
          "showWhen": "wrong"
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "v wordt f aan het eind",
            "content": "Bij werkwoorden met een v in de stam (proeven → proev) verandert de v in een f aan het eind van het woord: proef. Bij hij/zij voeg je -t toe: proeft.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "present_tense_third_person_v_to_f_fill",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Bepaal de stam: proeven − en = proev → proef (v wordt f aan het eind). 'De kok' is hij/zij, dus stam + t: proef + t = proeft.",
        "solutionSteps": [
          "Bepaal de stam: proeven − en = proev → proef (v → f)",
          "'De kok' = hij → stam + t",
          "proef + t = proeft"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.heel-ww-ipv-stam", "label": "Stam (ik-vorm) gebruikt bij hij/zij" },
          { "id": "sww.dt-overgeneralize", "label": "v/f wisseling niet toegepast" }
        ]
      }
    },
    {
      "id": "SWW-TT-STAM-008",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "fill_in",
      "question": "Wat is de stam van het werkwoord 'zwemmen'? Typ alleen de stam.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["zwem"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stam bepalen",
            "content": "De stam vind je door -en van het hele werkwoord af te halen: zwemmen → zwemm → zwem. Let op: dubbele medeklinkers worden enkel aan het eind van een woord.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "stem_finding_double_consonant_fill",
      "variantIndex": 8,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De stam vind je door -en af te halen: zwemmen → zwemm. Een woord eindigt niet op een dubbele medeklinker, dus zwemm → zwem. De stam is 'zwem'.",
        "solutionSteps": [
          "Haal -en af: zwemmen → zwemm",
          "Dubbele medeklinker wordt enkel aan het eind: zwemm → zwem",
          "De stam is 'zwem'"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.dt-overgeneralize", "label": "Dubbele medeklinker behouden in stam" }
        ]
      }
    },
    {
      "id": "SWW-TT-STAM-009",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "fill_in",
      "question": "Vul de juiste vorm in: 'Zij ... elke ochtend naar haar werk.' (fietsen)",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["fietst"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "verbTable",
          "data": {
            "verb": "fietsen",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["fiets", "fietst", "fietst"],
            "highlight": "hij/zij",
            "label": "Tegenwoordige Tijd"
          },
          "showWhen": "wrong"
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stam + t bij hij/zij/het",
            "content": "Bepaal de stam: fietsen − en = fiets. 'Zij' is 3e persoon → stam + t = fietst. Onthoud: ik = stam, jij/hij/zij = stam + t.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "present_tense_third_person_fill",
      "variantIndex": 9,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Bepaal de stam: fietsen − en = fiets. 'Zij' is 3e persoon enkelvoud → stam + t = fietst.",
        "solutionSteps": [
          "Bepaal de stam: fietsen − en = fiets",
          "'Zij' = 3e persoon enkelvoud → stam + t",
          "fiets + t = fietst"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "sww.heel-ww-ipv-stam", "label": "Stam (ik-vorm) gebruikt bij zij" }
        ]
      }
    },
    {
      "id": "SWW-TT-STAM-010",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "error_spotting",
      "question": "Zoek de werkwoordfouten in deze zinnen en verbeter ze.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Ik fietst elke dag naar school. Mijn broer lees een boek. De leraar vertelt een verhaal.",
        "errors": [
          {
            "word": "fietst",
            "position": 1,
            "correction": "fiets",
            "explanation": "'Ik' is 1e persoon → alleen de stam, zonder -t. Stam van fietsen = fiets."
          },
          {
            "word": "lees",
            "position": 5,
            "correction": "leest",
            "explanation": "'Mijn broer' = hij (3e persoon) → stam + t. Stam van lezen = lees → leest."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stam-regel tegenwoordige tijd",
            "content": "ik = stam (geen -t). jij/hij/zij = stam + t. Let op: 'De leraar vertelt' is correct (hij vertelt).",
            "icon": "lightbulb"
          }
        },
        {
          "type": "verbTable",
          "data": {
            "verb": "fietsen",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["fiets", "fietst", "fietst"],
            "highlight": "ik",
            "label": "Tegenwoordige Tijd"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "present_tense_error_spotting",
      "variantIndex": 10,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Fout 1: 'Ik fietst' → moet 'ik fiets' zijn (ik = stam, geen -t). Fout 2: 'Mijn broer lees' → moet 'leest' zijn (hij = stam + t). 'De leraar vertelt' is correct (hij vertelt).",
        "solutionSteps": [
          "Zin 1: 'Ik fietst' → ik = 1e persoon → stam zonder -t → 'ik fiets'",
          "Zin 2: 'Mijn broer lees' → mijn broer = hij (3e persoon) → stam + t → 'leest'",
          "Zin 3: 'De leraar vertelt' → hij = 3e persoon → stam 'vertel' + t = 'vertelt' ✓ (correct)"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "SWW-TT-STAM-011",
      "familyId": "SWW-TT-STAM",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_stam_regel",
      "questionType": "categorize",
      "question": "Sorteer deze werkwoordsvormen: hoort de vorm bij 'ik' of bij 'hij/zij'?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["ik-vorm (stam)", "hij/zij-vorm (stam + t)"],
        "items": [
          {"text": "fiets", "correctCategory": 0},
          {"text": "fietst", "correctCategory": 1},
          {"text": "wandel", "correctCategory": 0},
          {"text": "wandelt", "correctCategory": 1},
          {"text": "ren", "correctCategory": 0},
          {"text": "rent", "correctCategory": 1}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stam-regel",
            "content": "Bij 'ik' gebruik je alleen de stam (zonder -t): ik fiets, ik wandel, ik ren. Bij 'hij/zij' voeg je -t toe aan de stam: hij fietst, zij wandelt, hij rent. Onthoud: ik = stam, hij/zij = stam + t.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "present_tense_categorize_ik_hij",
      "variantIndex": 11,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Ik-vormen (stam zonder -t): fiets, wandel, ren. Hij/zij-vormen (stam + t): fietst, wandelt, rent. De regel: bij 'ik' gebruik je alleen de stam, bij 'hij/zij/het' voeg je -t toe.",
        "solutionSteps": [
          "fiets → geen -t → ik-vorm (stam)",
          "fietst → met -t → hij/zij-vorm (stam + t)",
          "wandel → geen -t → ik-vorm",
          "wandelt → met -t → hij/zij-vorm",
          "ren → geen -t → ik-vorm",
          "rent → met -t → hij/zij-vorm"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "sww.heel-ww-ipv-stam", "label": "Hij-vorm in ik-categorie of stam in hij-categorie geplaatst" },
          { "id": "sww.ik-vorm-met-t", "label": "Stam-zonder-t verkeerd gecategoriseerd" }
        ]
      }
    }
  ]
}